import Api from "./Api";

export const getMessages = (idPalestra) => {
  return Api().get(`/chat/${idPalestra}`);
};

export const sendMessage = (idPalestra, message) => {
  return Api().post(`/chat/${idPalestra}`, { message });
};
